__turbopack_context__.v({
  "actionButton": "AdaptiveFiltersDropdown-module-scss-module__oP9daa__actionButton",
  "indicatorIndicator": "AdaptiveFiltersDropdown-module-scss-module__oP9daa__indicatorIndicator",
  "indicatorRoot": "AdaptiveFiltersDropdown-module-scss-module__oP9daa__indicatorRoot",
  "label": "AdaptiveFiltersDropdown-module-scss-module__oP9daa__label",
  "opened": "AdaptiveFiltersDropdown-module-scss-module__oP9daa__opened",
});
